module.exports = __webpack_public_path__ + "img/form-1.13f59ef3.svg";